export const addDisabledField = (nodes) =>
  nodes?.map(({ isDisabled, children, ...node }) => ({
    ...node,
    disabled: isDisabled,
    children: children?.length ? addDisabledField(children) : [],
  })) || [];
